import {
  Avatar,
  Button,
  HStack,
  Icon,
  Skeleton,
  SkeletonCircle,
  SkeletonText,
  StackProps,
  Text,
  VStack,
} from "@chakra-ui/react";
import { RiAddLine, RiMapPin2Line } from "@remixicon/react";
import { useNavigate } from "react-router-dom";
import { DetailProductSupplierData } from "../../constants/Supplier";
import { useAddProduct } from "../../hooks/fetchApi";
import useScreenWidth from "../../lib/useScreenWidth";
import { explodeString } from "../../utils/helperFunction";
import { ListProductVariant } from "../card/ListProductVariant";
import { ProductAdded } from "../card/ProductAdded";
import { ReadMore } from "../card/ReadMore";
import { CardSkeleton } from "../skeleton/CardSkeleton";

interface Props extends StackProps {
  data: DetailProductSupplierData | undefined;
  loaded: boolean;
  onRefresh: () => void;
}

export const ProductSupplierInfo = ({
  data,
  loaded,
  onRefresh,
  ...rest
}: Props) => {
  const navigate = useNavigate();
  const sw = useScreenWidth();
  const { isFetchLoading, addProduct } = useAddProduct();

  const goToDetailSupplier = () => {
    navigate(`/reseller/search/supplier/${data?.supplier.id}`);
  };

  const addProductToStore = () => {
    addProduct(data?.product.id);
    onRefresh();
  };

  return (
    <VStack className="productinfo" gap={2} align={"stretch"} {...rest}>
      <Skeleton
        isLoaded={loaded}
        noOfLines={loaded ? undefined : 11}
        height={"30px"}
      >
        <Text textStyle={"h-title"}>{data?.product.name}</Text>
      </Skeleton>
      <Skeleton
        isLoaded={loaded}
        noOfLines={loaded ? undefined : 1}
        height={loaded ? undefined : "30px"}
      >
        <Text fontSize={[24, null, 28]} fontWeight={"bold"} color={"red.400"}>
          {data?.product.price}
        </Text>
      </Skeleton>
      <Text textStyle={"b-reg-sb"} mt={4}>
        Macam Varian
      </Text>
      {!loaded ? (
        data && <CardSkeleton row={3} height={80} />
      ) : (
        <ListProductVariant
          data={data?.product.variants}
          productId={data?.product.id}
        />
      )}
      <Text textStyle={"b-reg-sb"} mt={4}>
        Detail Produk
      </Text>
      <HStack>
        <Text textStyle={"b-reg"} variant={"secondary"}>
          Kategori
        </Text>
        <SkeletonText isLoaded={loaded} noOfLines={loaded ? undefined : 1}>
          <Text textStyle={"b-reg"}>{data?.product.category}</Text>
        </SkeletonText>
      </HStack>
      {!loaded ? (
        <SkeletonText isLoaded={loaded} noOfLines={loaded ? undefined : 4} />
      ) : (
        <ReadMore data={data?.product.description} />
      )}
      <HStack mt={4} cursor={"pointer"} onClick={goToDetailSupplier}>
        {!loaded ? (
          <SkeletonCircle isLoaded={loaded} size={"12"} />
        ) : (
          <Avatar
            name={data?.supplier.name || ""}
            src={
              data?.supplier.logo
                ? `${process.env.REACT_APP_MEDIA_URL}${data?.supplier.logo}`
                : ""
            }
            size={"md"}
          />
        )}

        <SkeletonText isLoaded={loaded} noOfLines={loaded ? undefined : 1}>
          <Text textStyle={"b-reg-sb"}>
            {data?.supplier.name || "Supplier BisnisLink"}
          </Text>
        </SkeletonText>
      </HStack>
      {data?.supplier.city && (
        <>
          <Text textStyle={"b-reg-sb"} mt={4}>
            Pengiriman
          </Text>

          <HStack gap={0}>
            <Icon as={RiMapPin2Line} />

            <Text textStyle={"b-reg"} ml={2}>
              Dikirim Dari
            </Text>

            <SkeletonText
              isLoaded={loaded}
              noOfLines={loaded ? undefined : 1}
              ml={1.5}
            >
              <Text textStyle={"b-reg-sb"}>
                {data?.supplier.city && explodeString(data?.supplier.city).nama}
              </Text>
            </SkeletonText>
          </HStack>
        </>
      )}
      {data?.product.added === 0 ? (
        <Button
          w={"fit-content"}
          size={["xs", null, "sm"]}
          mt={4}
          variant={"solid"}
          leftIcon={<Icon as={RiAddLine} />}
          colorScheme="red"
          isDisabled={loaded && !isFetchLoading ? false : true}
          onClick={addProductToStore}
        >
          Tambahkan ke Store Saya
        </Button>
      ) : (
        <ProductAdded mt={4} />
      )}
    </VStack>
  );
};
